import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { formatMessage } from "devextreme/localization";
import { CalculatorUsFieldItemsService } from "../../../../../services/calculator-us-field-items.service";
import { UsCalculatorFieldItem } from "../../../../../model/calculator-us-remastered/usCalculatorFieldItem";
import { SummaryEvent } from "../calculator-prepress/calculator-prepress.component";
import { DxAccordionComponent, DxFormComponent } from "devextreme-angular";
import {
  ComponentSpecification,
  EndsheetSpecification,
  InsertSpecification,
  TipInSpecification,
} from "../../../../../model/calculator-us-remastered/componentSpecification";
import { SummaryItem } from "../../../../../model/calculator-us-remastered/summaryItem";

export class Insert {
  id: number;
  selectedPages: UsCalculatorFieldItem | null;
  selectedPaper: UsCalculatorFieldItem | null;
  selectedColors: UsCalculatorFieldItem | null;
  selectedSpecialInk: UsCalculatorFieldItem | null;

  constructor(
    id: number,
    selectedSpecialInk: UsCalculatorFieldItem | null = null
  ) {
    this.id = id;
    this.selectedPages = null;
    this.selectedPaper = null;
    this.selectedColors = null;
    this.selectedSpecialInk = selectedSpecialInk;
  }
}

export class TipIn {
  id: number;
  selectedPages: string;
  selectedPaper: UsCalculatorFieldItem | null;
  selectedColors: UsCalculatorFieldItem | null;
  selectedSpecialInk: UsCalculatorFieldItem | null;

  constructor(
    id: number,
    selectedSpecialInk: UsCalculatorFieldItem | null = null
  ) {
    this.id = id;
    this.selectedPages = "2 Pages"; // Default is always 2, only for display purpose
    this.selectedPaper = null;
    this.selectedColors = null;
    this.selectedSpecialInk = selectedSpecialInk;
  }
}

@Component({
  selector: "app-calculator-component-specification",
  templateUrl: "./calculator-component-specification.component.html",
  styleUrls: ["./calculator-component-specification.component.scss"],
})
export class CalculatorComponentSpecificationComponent {
  _withComponents: boolean = false;

  _components: ComponentSpecification;
  @Input()
  set components(val: ComponentSpecification | undefined) {
    if (val) {
      this._components = val;
    } else {
      this._components = new ComponentSpecification();
    }
  }
  get components(): ComponentSpecification {
    return this._components;
  }

  @Input() selectedPublisherId: string | undefined;
  _selectedClassification: string | undefined;
  @Input()
  set selectedClassification(val: string | undefined) {
    this._selectedClassification = val;
    // // Determine if components are included (WITH, WITHOUT, COMPONENTS)
    this._withComponents = !val?.includes("WITHOUT") || false;

    this.components = new ComponentSpecification();
    this.resetFieldItems();
    this.loadFieldItems();

    this.onValueChanged.emit(this.components);
    this.summaryUpdate.emit([]);

    if (this.accordion) this.accordion.instance.collapseItem(0).then();
  }
  get selectedClassification(): string | undefined {
    return this._selectedClassification;
  }
  @Output() summaryUpdate = new EventEmitter<SummaryItem[]>();
  @Output() printedEndsheetStatusChange = new EventEmitter<boolean>(); // Neues Event für Endsheet Status
  @Output() onValueChanged = new EventEmitter<ComponentSpecification>();

  @ViewChild("jacketForm") jacketForm: DxFormComponent;
  @ViewChild("endsheetForm") endsheetForm: DxFormComponent;
  @ViewChild("accordion") accordion: DxAccordionComponent;

  formatMessage = formatMessage;
  collapsed: any = true;

  get specialEffectsText(): string {
    if (
      !this.selectedSpecialEffects ||
      this.selectedSpecialEffects.length === 0
    ) {
      return "None";
    }
    return this.selectedSpecialEffects.map((se) => se.displayValue).join(", ");
  }

  // Data Sources für die Dropdown-Felder
  jacketPaperFieldItems: UsCalculatorFieldItem[] = [];
  frontColorFieldItems: UsCalculatorFieldItem[] = [];
  backColorFieldItems: UsCalculatorFieldItem[] = [];
  finishingFieldItems: UsCalculatorFieldItem[] = [];
  specialEffectsFieldItems: UsCalculatorFieldItem[] = [];

  // Endsheet specific fields
  endsheetPaperFieldItems: UsCalculatorFieldItem[] = [];
  endsheetFrontColorFieldItems: UsCalculatorFieldItem[] = [];
  endsheetBackColorFieldItems: UsCalculatorFieldItem[] = [];

  // Insert specific fields
  insertPagesFieldItems: UsCalculatorFieldItem[] = [];
  insertPaperFieldItems: UsCalculatorFieldItem[] = [];
  insertColorsFieldItems: UsCalculatorFieldItem[] = [];
  insertSpecialInkFieldItems: UsCalculatorFieldItem[] = [];

  // Tip-In specific fields
  tipInPaperFieldItems: UsCalculatorFieldItem[] = [];
  tipInColorsFieldItems: UsCalculatorFieldItem[] = [];
  tipInSpecialInkFieldItems: UsCalculatorFieldItem[] = [];

  // Selected Values - Jacket/Cover
  _selectedJacketPaper: UsCalculatorFieldItem | null = null;
  set selectedJacketPaper(val: UsCalculatorFieldItem | null) {
    this._selectedJacketPaper = val;
    this.updateSummary();
    if (this.isHardcover()) {
      this._components.jacket.jacketPaper = val?.keyValue;
    }
    if (this.isSoftcover()) {
      this._components.cover.jacketPaper = val?.keyValue;
    }
    this.onValueChanged.emit(this.components);
  }
  get selectedJacketPaper(): UsCalculatorFieldItem | null {
    return this._selectedJacketPaper;
  }
  _selectedFrontColor: UsCalculatorFieldItem | null = null;
  set selectedFrontColor(val: UsCalculatorFieldItem | null) {
    this._selectedFrontColor = val;
    this.updateSummary();
    if (this.isHardcover()) {
      this._components.jacket.frontColor = val?.keyValue;
    }
    if (this.isSoftcover()) {
      this._components.cover.frontColor = val?.keyValue;
    }
    this.onValueChanged.emit(this.components);
  }
  get selectedFrontColor(): UsCalculatorFieldItem | null {
    return this._selectedFrontColor;
  }
  _selectedBackColor: UsCalculatorFieldItem | null = null;
  set selectedBackColor(val: UsCalculatorFieldItem | null) {
    this._selectedBackColor = val;
    this.updateSummary();
    if (this.isHardcover()) {
      this._components.jacket.backColor = val?.keyValue;
    }
    if (this.isSoftcover()) {
      this._components.cover.backColor = val?.keyValue;
    }
    this.onValueChanged.emit(this.components);
  }
  get selectedBackColor(): UsCalculatorFieldItem | null {
    return this._selectedBackColor;
  }
  _selectedFinishing: UsCalculatorFieldItem | null = null;
  set selectedFinishing(val: UsCalculatorFieldItem | null) {
    this._selectedFinishing = val;
    this.updateSummary();
    if (this.isHardcover()) {
      this._components.jacket.finishing = val?.keyValue;
    }
    if (this.isSoftcover()) {
      this._components.cover.finishing = val?.keyValue;
    }
    this.onValueChanged.emit(this.components);
  }
  get selectedFinishing(): UsCalculatorFieldItem | null {
    return this._selectedFinishing;
  }
  _selectedSpecialEffects: UsCalculatorFieldItem[] = [];
  set selectedSpecialEffects(val: UsCalculatorFieldItem[] | null | undefined) {
    this._selectedSpecialEffects = val && Array.isArray(val) ? val : [];

    if (this.isHardcover()) {
      this._components.jacket.specialEffects = this._selectedSpecialEffects
        .map((se) => se.keyValue)
        .filter((keyValue): keyValue is string => keyValue !== undefined);
    }
    if (this.isSoftcover()) {
      this._components.cover.specialEffects = this._selectedSpecialEffects
        .map((se) => se.keyValue)
        .filter((keyValue): keyValue is string => keyValue !== undefined);
    }

    this.updateSummary();
    this.onValueChanged.emit(this.components);
  }
  get selectedSpecialEffects(): UsCalculatorFieldItem[] {
    return this._selectedSpecialEffects;
  }

  // Selected Values - Endsheets
  _selectedEndsheetPaper: UsCalculatorFieldItem | null = null;
  set selectedEndsheetPaper(val: UsCalculatorFieldItem | null) {
    this._selectedEndsheetPaper = val;
    this.updateSummary();
    this._components.endsheet.paper = val?.keyValue;
    this.onValueChanged.emit(this.components);
  }
  get selectedEndsheetPaper(): UsCalculatorFieldItem | null {
    return this._selectedEndsheetPaper;
  }
  _selectedEndsheetFrontColor: UsCalculatorFieldItem | null = null;
  set selectedEndsheetFrontColor(val: UsCalculatorFieldItem | null) {
    this._selectedEndsheetFrontColor = val;
    this.updateSummary();
    this._components.endsheet.frontColor = val?.keyValue;
    this.onValueChanged.emit(this.components);
  }
  get selectedEndsheetFrontColor(): UsCalculatorFieldItem | null {
    return this._selectedEndsheetFrontColor;
  }
  _selectedEndsheetBackColor: UsCalculatorFieldItem | null = null;
  set selectedEndsheetBackColor(val: UsCalculatorFieldItem | null) {
    this._selectedEndsheetBackColor = val;
    this.updateSummary();
    this._components.endsheet.backColor = val?.keyValue;
    this.onValueChanged.emit(this.components);
  }
  get selectedEndsheetBackColor(): UsCalculatorFieldItem | null {
    return this._selectedEndsheetBackColor;
  }

  // Toggle States
  endsheetEnabled: boolean = false; // Standardmäßig deaktiviert

  // Insert Management
  inserts: Insert[] = [];
  nextInsertId: number = 1;

  tipIns: TipIn[] = [];
  nextTipInId: number = 1;

  onAccordionClick(e) {
    this.collapsed = e.component.option("selectedIndex") == -1;
  }

  constructor(
    private calculatorUsFieldItemsService: CalculatorUsFieldItemsService
  ) {}

  /**
   * Bestimmt ob es sich um Hardcover handelt (für Jacket vs. Cover Label)
   */
  isHardcover(): boolean {
    return (
      this.selectedClassification?.toUpperCase().includes("HARDCOVER") || false
    );
  }

  isSoftcover(): boolean {
    return (
      this.selectedClassification?.toUpperCase().includes("SOFTCOVER") || false
    );
  }

  /**
   * Setzt alle Werte zurück (wird bei Produktwechsel aufgerufen)
   */
  private resetFieldItems(): void {
    // Reset selected values
    this.selectedJacketPaper = null;
    this.selectedFrontColor = null;
    this.selectedBackColor = null;
    this.selectedFinishing = null;
    this.selectedSpecialEffects = [];
    this.selectedEndsheetPaper = null;
    this.selectedEndsheetFrontColor = null;
    this.selectedEndsheetBackColor = null;

    // Reset field items
    this.jacketPaperFieldItems = [];
    this.frontColorFieldItems = [];
    this.backColorFieldItems = [];
    this.finishingFieldItems = [];
    this.specialEffectsFieldItems = [];
    this.endsheetPaperFieldItems = [];
    this.endsheetFrontColorFieldItems = [];
    this.endsheetBackColorFieldItems = [];
    this.insertPagesFieldItems = [];
    this.insertPaperFieldItems = [];
    this.insertColorsFieldItems = [];
    this.insertSpecialInkFieldItems = [];
    this.tipInPaperFieldItems = [];
    this.tipInColorsFieldItems = [];

    // Reset inserts and tip ins
    this.inserts = [];
    this.tipIns = [];
  }

  private loadFieldItems(): void {
    if (!this.selectedPublisherId || !this.selectedClassification) {
      return;
    }

    // Only load if components are included
    if (this._withComponents) {
      const noneSpecialInk = <UsCalculatorFieldItem>{
        keyValue: "NONE",
        displayValue: "None",
      };

      this.insertSpecialInkFieldItems.push({ ...noneSpecialInk });
      this.tipInSpecialInkFieldItems.push({ ...noneSpecialInk });

      // Verwende die neue optimierte Methode für gesammelte Subkategorie-Abfrage
      this.calculatorUsFieldItemsService
        .getFieldItemsBySubcategory(
          this.selectedPublisherId,
          this.calculatorUsFieldItemsService.getDbClassification(
            this.selectedClassification
          ),
          [
            "COMPONENT_COVER",
            "COMPONENT_JACKET",
            "COMPONENT_ENDSHEET",
            "COMPONENT_INSERT",
            "COMPONENT_TIPIN",
          ]
        )
        .subscribe((fieldItems) => {
          // Mapping über fieldItem.inputName wie in der Hauptkomponente
          for (const fieldItem of fieldItems) {
            // Jacket/Cover fields
            if (
              fieldItem.subcategory === "COMPONENT_JACKET" ||
              fieldItem.subcategory === "COMPONENT_COVER"
            ) {
              if (fieldItem.inputName === "PAPER") {
                this.jacketPaperFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  this.selectedJacketPaper = fieldItem;
                }
              } else if (fieldItem.inputName === "FRONT_COLOR") {
                this.frontColorFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  this.selectedFrontColor = fieldItem;
                }
              } else if (fieldItem.inputName === "BACK_COLOR") {
                this.backColorFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  this.selectedBackColor = fieldItem;
                }
              } else if (fieldItem.inputName === "FINISHING") {
                this.finishingFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  this.selectedFinishing = fieldItem;
                }
              } else if (fieldItem.inputName === "SPECIAL_EFFECTS") {
                this.specialEffectsFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  this.selectedSpecialEffects.push(fieldItem);
                }
              }
            }

            // Endsheet fields
            if (fieldItem.subcategory === "COMPONENT_ENDSHEET") {
              if (fieldItem.inputName === "PAPER") {
                this.endsheetPaperFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  this.selectedEndsheetPaper = fieldItem;
                }
              } else if (fieldItem.inputName === "FRONT_COLOR") {
                this.endsheetFrontColorFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  this.selectedEndsheetFrontColor = fieldItem;
                }
              } else if (fieldItem.inputName === "BACK_COLOR") {
                this.endsheetBackColorFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  this.selectedEndsheetBackColor = fieldItem;
                }
              }
            }

            // Insert fields - für Inserts nehmen wir vom ersten Insert Objekt aus wie Sie sagten
            if (fieldItem.subcategory === "COMPONENT_INSERT") {
              if (fieldItem.inputName === "PAGES") {
                this.insertPagesFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  if (this.inserts.length === 0) {
                    // Initialisiere das erste Insert mit dem Default-Wert
                    const insert = new Insert(
                      this.nextInsertId,
                      this.insertSpecialInkFieldItems[0]
                    );
                    this.inserts.push(insert);
                    const componentInsert = new InsertSpecification(
                      this.nextInsertId
                    );
                    this._components.inserts.push(componentInsert);
                    this.nextInsertId++;
                  }
                  this.inserts[0].selectedPages = fieldItem;
                  this._components.inserts[0].pages = fieldItem.keyValue;
                }
                // Kein Default für Insert Pages - wird dynamisch gesetzt
              } else if (fieldItem.inputName === "PAPER") {
                this.insertPaperFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  if (this.inserts.length === 0) {
                    // Initialisiere das erste Insert mit dem Default-Wert
                    const insert = new Insert(
                      this.nextInsertId,
                      this.insertSpecialInkFieldItems[0]
                    );
                    this.inserts.push(insert);
                    const componentInsert = new InsertSpecification(
                      this.nextInsertId
                    );
                    this._components.inserts.push(componentInsert);
                    this.nextInsertId++;
                  }
                  this.inserts[0].selectedPaper = fieldItem;
                  this._components.inserts[0].paper = fieldItem.keyValue;
                }
              } else if (fieldItem.inputName === "COLOR") {
                this.insertColorsFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  if (this.inserts.length === 0) {
                    // Initialisiere das erste Insert mit dem Default-Wert
                    const insert = new Insert(
                      this.nextInsertId,
                      this.insertSpecialInkFieldItems[0]
                    );
                    this.inserts.push(insert);
                    const componentInsert = new InsertSpecification(
                      this.nextInsertId
                    );
                    this._components.inserts.push(componentInsert);
                    this.nextInsertId++;
                  }
                  this.inserts[0].selectedColors = fieldItem;
                  this._components.inserts[0].color = fieldItem.keyValue;
                }
              } /* else if (fieldItem.inputName === "SPECIAL_INK") {
                this.insertSpecialInkFieldItems.push(fieldItem);
                if (fieldItem.isDefault) {
                  if (this.inserts.length === 0) {
                    // Initialisiere das erste Insert mit dem Default-Wert
                    const insert = new Insert(this.nextInsertId);
                    this.inserts.push(insert);
                    const componentInsert = new InsertSpecification(
                      this.nextInsertId
                    );
                    this._components.inserts.push(componentInsert);

                    this.nextInsertId++;
                  }
                  this.inserts[0].selectedSpecialInk = fieldItem;
                  this._components.inserts[0].specialInk = fieldItem.keyValue;
                }
              } */
            }
            // TIP-IN
            if (fieldItem.subcategory === "COMPONENT_TIPIN") {
              if (fieldItem.inputName === "PAPER") {
                this.tipInPaperFieldItems.push(fieldItem);
              } else if (fieldItem.inputName === "COLOR") {
                this.tipInColorsFieldItems.push(fieldItem);
              }
            }
          }

          // Sort fields alphabetically
          this.frontColorFieldItems.sort((a, b) =>
            a.displayValue!!.localeCompare(b.displayValue!!)
          );
          this.backColorFieldItems.sort((a, b) =>
            a.displayValue!!.localeCompare(b.displayValue!!)
          );
          this.finishingFieldItems.sort((a, b) =>
            a.displayValue!!.localeCompare(b.displayValue!!)
          );
          this.specialEffectsFieldItems.sort((a, b) =>
            a.displayValue!!.localeCompare(b.displayValue!!)
          );

          // Ensure selectedSpecialEffects is always initialized as empty array if no defaults were set
          if (
            !this.selectedSpecialEffects ||
            this.selectedSpecialEffects.length === 0
          ) {
            this.selectedSpecialEffects = [];
          }
        });
    }
  }

  /**
   * Setzt den Default-Wert für ein Feld basierend auf den geladenen Items
   */
  private setDefaultValue(
    items: UsCalculatorFieldItem[],
    fieldName: string
  ): void {
    const defaultItem = items.find((item) => item.isDefault);
    if (defaultItem) {
      this[fieldName] = defaultItem;
    } else {
      this[fieldName] = null;
    }
  }

  /**
   * Toggle-Funktionalität für Endsheets
   */
  toggleEndsheet(): void {
    this.endsheetEnabled = !this.endsheetEnabled;

    // Event an Parent senden für Paper Specification
    this.printedEndsheetStatusChange.emit(this.endsheetEnabled);

    // Wenn deaktiviert, reset der selected values
    if (!this.endsheetEnabled) {
      this.selectedEndsheetPaper = null;
      this.selectedEndsheetFrontColor = null;
      this.selectedEndsheetBackColor = null;

      this._components.endsheet = new EndsheetSpecification();
    } else {
      // Restore default values from field items
      this.restoreEndsheetDefaults();
      // Wait a bit to ensure values are set, then update
      setTimeout(() => {
        this.updateSummary();
      }, 10);
    }
  }

  /**
   * Stellt die Default-Werte für Endsheets wieder her
   */
  private restoreEndsheetDefaults(): void {
    this.setDefaultValue(this.endsheetPaperFieldItems, "selectedEndsheetPaper");
    this.setDefaultValue(
      this.endsheetFrontColorFieldItems,
      "selectedEndsheetFrontColor"
    );
    this.setDefaultValue(
      this.endsheetBackColorFieldItems,
      "selectedEndsheetBackColor"
    );
  }

  /**
   * Insert Management - Neue Insert-Kachel hinzufügen
   */
  addInsert(): void {
    this._components.inserts.push({
      id: this.nextInsertId,
      pages: undefined,
      paper: undefined,
      color: undefined,
      specialInk: undefined,
    });
    this.onValueChanged.emit(this.components);

    const newInsert = new Insert(
      this.nextInsertId,
      this.insertSpecialInkFieldItems[0]
    );
    this.inserts.push(newInsert);
    this.nextInsertId++;
    this.updateSummary();
  }

  /**
   * Insert entfernen
   */
  removeInsert(insertId: number): void {
    this.inserts = this.inserts.filter((insert) => insert.id !== insertId);
    this._components.inserts = this._components.inserts.filter(
      (insert) => insert.id !== insertId
    );
    this.onValueChanged.emit(this.components);
    this.updateSummary();
  }

  /**
   * Insert Paper Änderung
   */
  insertPaperChanged(event: any, insertId: number): void {
    const insert = this.inserts.find((i) => i.id === insertId);
    if (insert) {
      insert.selectedPaper = event.value
        ? this.insertPaperFieldItems.find(
            (item) => item.keyValue === event.value
          ) || null
        : null;

      const componentInsert = this.components.inserts.find(
        (insert) => insert.id === insertId
      );
      if (componentInsert) {
        componentInsert.paper = insert.selectedPaper?.keyValue;
      }
      this.onValueChanged.emit(this.components);

      this.updateSummary();
    }
  }

  /**
   * Insert Color Änderung
   */
  insertColorsChanged(event: any, insertId: number): void {
    const insert = this.inserts.find((i) => i.id === insertId);
    if (insert) {
      insert.selectedColors = event.value
        ? this.insertColorsFieldItems.find(
            (item) => item.keyValue === event.value
          ) || null
        : null;

      const componentInsert = this.components.inserts.find(
        (insert) => insert.id === insertId
      );
      if (componentInsert) {
        componentInsert.color = insert.selectedColors?.keyValue;
      }
      this.onValueChanged.emit(this.components);

      this.updateSummary();
    }
  }

  /**
   * Insert Pages Änderung - wichtig für Tip-In Logik
   */
  insertPagesChanged(event: any, insertId: number): void {
    const insert = this.inserts.find((i) => i.id === insertId);
    if (insert) {
      insert.selectedPages = event.value
        ? this.insertPagesFieldItems.find(
            (item) => item.keyValue === event.value
          ) || null
        : null;

      const componentInsert = this.components.inserts.find(
        (insert) => insert.id === insertId
      );
      if (componentInsert) {
        componentInsert.pages = insert.selectedPages?.keyValue;
      }

      this.onValueChanged.emit(this.components);
      this.updateSummary();
    }
  }

  /**
   * Insert Special Ink Änderung
   */
  insertSpecialInkChanged(event: any, insertId: number): void {
    const insert = this.inserts.find((i) => i.id === insertId);
    if (insert) {
      insert.selectedSpecialInk = event.value
        ? this.insertSpecialInkFieldItems.find(
            (item) => item.keyValue === event.value
          ) || null
        : null;

      const componentInsert = this.components.inserts.find(
        (insert) => insert.id === insertId
      );
      if (componentInsert) {
        componentInsert.specialInk = insert.selectedSpecialInk?.keyValue;
      }

      this.onValueChanged.emit(this.components);
      this.updateSummary();
    }
  }

  // TIP-IN
  addTipIn(): void {
    const newComponentTipIn = new TipInSpecification(this.nextTipInId);
    this._components.tipIns.push(newComponentTipIn);

    const newTipIn = new TipIn(
      this.nextTipInId,
      this.tipInSpecialInkFieldItems[0]
    );
    this.tipIns.push(newTipIn);

    this.nextTipInId++;
    this.onValueChanged.emit(this.components);
    this.updateSummary();
  }

  removeTipIn(tipInId: number): void {
    this.tipIns = this.tipIns.filter((tipIn) => tipIn.id !== tipInId);
    this._components.tipIns = this._components.tipIns.filter(
      (tipIn) => tipIn.id !== tipInId
    );

    this.onValueChanged.emit(this.components);
    this.updateSummary();
  }

  tipInPaperChanged(event: any, tipInId: number): void {
    const tipIn = this.tipIns.find((i) => i.id === tipInId);
    if (tipIn) {
      tipIn.selectedPaper = event.value
        ? this.tipInPaperFieldItems.find(
            (item) => item.keyValue === event.value
          ) || null
        : null;
      const componentTipIn = this.components.tipIns.find(
        (tipIn) => tipIn.id === tipInId
      );
      if (componentTipIn) {
        componentTipIn.paper = tipIn.selectedPaper?.keyValue;
      }

      this.onValueChanged.emit(this.components);
      this.updateSummary();
    }
  }

  tipInColorsChanged(event: any, tipInId: number): void {
    const tipIn = this.tipIns.find((i) => i.id === tipInId);
    if (tipIn) {
      tipIn.selectedColors = event.value
        ? this.tipInColorsFieldItems.find(
            (item) => item.keyValue === event.value
          ) || null
        : null;

      const componentTipIn = this.components.tipIns.find(
        (tipIn) => tipIn.id === tipInId
      );
      if (componentTipIn) {
        componentTipIn.color = tipIn.selectedColors?.keyValue;
      }

      this.onValueChanged.emit(this.components);
      this.updateSummary();
    }
  }

  tipInSpecialInkChanged(event: any, tipInId: number): void {
    const tipIn = this.tipIns.find((i) => i.id === tipInId);
    if (tipIn) {
      tipIn.selectedSpecialInk = event.value
        ? this.tipInSpecialInkFieldItems.find(
            (item) => item.keyValue === event.value
          ) || null
        : null;

      const componentTipIn = this.components.tipIns.find(
        (tipIn) => tipIn.id === tipInId
      );
      if (componentTipIn) {
        componentTipIn.specialInk = tipIn.selectedSpecialInk?.keyValue;
      }

      this.onValueChanged.emit(this.components);
      this.updateSummary();
    }
  }

  /**
   * Aktualisiert die Summary mit allen Component Specification Werten
   */
  private updateSummary(): void {
    const summaryItems: SummaryItem[] = [];
    const jacketCoverLabel = this.isHardcover() ? "Jacket" : "Cover";

    function findDefault(dS: UsCalculatorFieldItem[]) {
      return dS.find((item) => item.isDefault) || null;
    }

    // Jacket/Cover Felder
    if (this.selectedJacketPaper) {
      const defaultJacketPaper = findDefault(this.jacketPaperFieldItems);
      summaryItems.push(
        new SummaryItem(
          "selectedJacketPaper",
          "Paper",
          this.selectedJacketPaper.displayValue,
          defaultJacketPaper?.displayValue || "",
          `Component Specification - ${jacketCoverLabel}`,
          undefined
        )
      );
    }

    if (this.selectedFrontColor) {
      const defaultFrontColor = findDefault(this.frontColorFieldItems);
      summaryItems.push(
        new SummaryItem(
          "selectedFrontColor",
          "Front Color",
          this.selectedFrontColor.displayValue,
          defaultFrontColor?.displayValue || "",
          `Component Specification - ${jacketCoverLabel}`,
          undefined
        )
      );
    }

    if (this.selectedBackColor) {
      const defaultBackColor = findDefault(this.backColorFieldItems);
      summaryItems.push(
        new SummaryItem(
          "selectedBackColor",
          "Back Color",
          this.selectedBackColor.displayValue,
          defaultBackColor?.displayValue || "",
          `Component Specification - ${jacketCoverLabel}`,
          undefined
        )
      );
    }

    if (this.selectedFinishing) {
      const defaultFinishing = findDefault(this.finishingFieldItems);
      summaryItems.push(
        new SummaryItem(
          "selectedFinishing",
          "Finishing",
          this.selectedFinishing.displayValue,
          defaultFinishing?.displayValue || "",
          `Component Specification - ${jacketCoverLabel}`,
          undefined
        )
      );
    }

    if (this.selectedSpecialEffects.length > 0) {
      const defaultSpecialEffects = findDefault(this.specialEffectsFieldItems);
      summaryItems.push(
        new SummaryItem(
          "selectedSpecialEffects",
          "Special Effects",
          this.selectedSpecialEffects?.map((se) => se.displayValue).join("\n"),
          defaultSpecialEffects?.displayValue || "",
          `Component Specification - ${jacketCoverLabel}`,
          undefined
        )
      );
    }

    // Endsheet Felder (nur wenn aktiviert)
    if (this.selectedEndsheetPaper && this.endsheetEnabled) {
      const defaultEndsheetPaper = findDefault(this.endsheetPaperFieldItems);
      summaryItems.push(
        new SummaryItem(
          "selectedEndsheetPaper",
          "Paper",
          this.selectedEndsheetPaper.displayValue,
          defaultEndsheetPaper?.displayValue || "",
          "Component Specification - Endsheet",
          undefined
        )
      );
    }

    if (this.selectedEndsheetFrontColor && this.endsheetEnabled) {
      const defaultEndsheetFrontColor = findDefault(
        this.endsheetFrontColorFieldItems
      );
      summaryItems.push(
        new SummaryItem(
          "selectedEndsheetFrontColor",
          "Front Color",
          this.selectedEndsheetFrontColor.displayValue,
          defaultEndsheetFrontColor?.displayValue || "",
          "Component Specification - Endsheet",
          undefined
        )
      );
    }

    if (this.selectedEndsheetBackColor && this.endsheetEnabled) {
      const defaultEndsheetBackColor = findDefault(
        this.endsheetBackColorFieldItems
      );
      summaryItems.push(
        new SummaryItem(
          "selectedEndsheetBackColor",
          "Back Color",
          this.selectedEndsheetBackColor.displayValue,
          defaultEndsheetBackColor?.displayValue || "",
          "Component Specification - Endsheet",
          undefined
        )
      );
    }

    // Insert Items zur Summary hinzufügen
    this.inserts.forEach((insert, insertCounter) => {
      const numberedTitle = `Insert ${insertCounter + 1}`;
      const insertCategory = `Component Specification - ${numberedTitle}`;

      if (insert.selectedPages) {
        const defaultPages = findDefault(this.insertPagesFieldItems);
        const summaryItemPages = new SummaryItem(
          `insertPages_${insert.id}`,
          "Pages",
          insert.selectedPages.displayValue,
          defaultPages?.displayValue || "",
          insertCategory,
          undefined
        );
        // inserts do not show changes in the summary
        summaryItemPages.changed = false;
        summaryItems.push(summaryItemPages);
      }

      if (insert.selectedPaper) {
        const defaultPaper = findDefault(this.insertPaperFieldItems);
        const summaryItemPaper = new SummaryItem(
          `insertPaper_${insert.id}`,
          "Paper",
          insert.selectedPaper.displayValue,
          defaultPaper?.displayValue || "",
          insertCategory,
          undefined
        );
        // inserts do not show changes in the summary
        summaryItemPaper.changed = false;
        summaryItems.push(summaryItemPaper);
      }

      if (insert.selectedColors) {
        const defaultColors = findDefault(this.insertColorsFieldItems);
        const summaryItemColors = new SummaryItem(
          `insertColors_${insert.id}`,
          "Colors",
          insert.selectedColors.displayValue,
          defaultColors?.displayValue || "",
          insertCategory,
          undefined
        );
        // inserts do not show changes in the summary
        summaryItemColors.changed = false;
        summaryItems.push(summaryItemColors);
      }

      if (insert.selectedSpecialInk) {
        const defaultSpecialInk = findDefault(this.insertSpecialInkFieldItems);
        const summaryItemSpecialInk = new SummaryItem(
          `insertSpecialInk_${insert.id}`,
          "Special Ink",
          insert.selectedSpecialInk.displayValue,
          defaultSpecialInk?.displayValue || "",
          insertCategory,
          undefined
        );
        // inserts do not show changes in the summary
        summaryItemSpecialInk.changed = false;
        summaryItems.push(summaryItemSpecialInk);
      }
    });

    // add tip-ins to the summary
    this.tipIns.forEach((tipIn, tipInCounter) => {
      const numberedTitle = `Tip In ${tipInCounter + 1}`;
      const tipInCategory = `Component Specification - ${numberedTitle}`;

      if (tipIn.selectedPages) {
        const defaultPages = "2 Pages"; // always 2 for tip ins
        const summaryItemPages = new SummaryItem(
          `tipInPages_${tipIn.id}`,
          "Pages",
          tipIn.selectedPages,
          defaultPages || "",
          tipInCategory,
          undefined
        );
        // inserts do not show changes in the summary
        summaryItemPages.changed = false;
        summaryItems.push(summaryItemPages);
      }

      if (tipIn.selectedPaper) {
        const defaultPaper = findDefault(this.tipInPaperFieldItems);
        const summaryItemPaper = new SummaryItem(
          `tipInPaper_${tipIn.id}`,
          "Paper",
          tipIn.selectedPaper.displayValue,
          defaultPaper?.displayValue || "",
          tipInCategory,
          undefined
        );
        // tip-ins do not show changes in the summary
        summaryItemPaper.changed = false;
        summaryItems.push(summaryItemPaper);
      }

      if (tipIn.selectedColors) {
        const defaultColors = findDefault(this.tipInColorsFieldItems);
        const summaryItemColors = new SummaryItem(
          `tipInColors_${tipIn.id}`,
          "Colors",
          tipIn.selectedColors.displayValue,
          defaultColors?.displayValue || "",
          tipInCategory,
          undefined
        );
        // tip-ins do not show changes in the summary
        summaryItemColors.changed = false;
        summaryItems.push(summaryItemColors);
      }

      if (tipIn.selectedSpecialInk) {
        const defaultSpecialInk = findDefault(this.tipInSpecialInkFieldItems);
        const summaryItemSpecialInk = new SummaryItem(
          `tipInSpecialInk_${tipIn.id}`,
          "Special Ink",
          tipIn.selectedSpecialInk.displayValue,
          defaultSpecialInk?.displayValue || "",
          tipInCategory,
          undefined
        );
        // inserts do not show changes in the summary
        summaryItemSpecialInk.changed = false;
        summaryItems.push(summaryItemSpecialInk);
      }
    });

    this.summaryUpdate.emit(summaryItems);
  }
}
